import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accept", "buttonRef", "cancelButtonText", "cancelUploadButtonTitle", "deleteFileButtonTitle", "disabled", "dragAndDropText", "errorText", "getUploadProgressAriaLabel", "getUploadProgressSummary", "id", "isMulti", "maxFiles", "onFileAttached", "renderFileDetailsIcon", "renderFileDetailsLabel", "renderRejectedErrorText", "retryButtonText", "showDropZone", "showFileDetails", "uploadButtonAriaDescribedby", "uploadButtonSize", "uploadButtonTitle", "uploadButtonVariant", "uploadHandler", "uploadIconTitle", "uploadProgressAriaLive"];
import React, { forwardRef, useCallback, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { describe } from '@amzn/stencil-react-desc';
import { Col } from "../layout";
import { useBreakpoints } from "../responsive";
import { pickDataProps, withTestAttributes } from "../utils";
import FileUploadWithDropzone from "./FileUploadWithDropzone";
import FileUploadWithoutDropzone from "./FileUploadWithoutDropzone";
import { defaultProps, FILE_UPLOAD_BLOCKS_SPACER_HEIGHT } from "./constants";
import { propTypes as FileUploadPropTypes } from "./propTypes";
import { jsx as ___EmotionJSX } from "@emotion/core";
var FileUploadWithoutDocs = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$accept = _ref.accept,
      accept = _ref$accept === void 0 ? defaultProps.accept : _ref$accept,
      buttonRefProp = _ref.buttonRef,
      _ref$cancelButtonText = _ref.cancelButtonText,
      cancelButtonText = _ref$cancelButtonText === void 0 ? defaultProps.cancelButtonText : _ref$cancelButtonText,
      _ref$cancelUploadButt = _ref.cancelUploadButtonTitle,
      cancelUploadButtonTitle = _ref$cancelUploadButt === void 0 ? defaultProps.cancelUploadButtonTitle : _ref$cancelUploadButt,
      _ref$deleteFileButton = _ref.deleteFileButtonTitle,
      deleteFileButtonTitle = _ref$deleteFileButton === void 0 ? defaultProps.deleteFileButtonTitle : _ref$deleteFileButton,
      disabled = _ref.disabled,
      _ref$dragAndDropText = _ref.dragAndDropText,
      dragAndDropText = _ref$dragAndDropText === void 0 ? defaultProps.dragAndDropText : _ref$dragAndDropText,
      _ref$errorText = _ref.errorText,
      errorText = _ref$errorText === void 0 ? defaultProps.errorText : _ref$errorText,
      _ref$getUploadProgres = _ref.getUploadProgressAriaLabel,
      getUploadProgressAriaLabel = _ref$getUploadProgres === void 0 ? defaultProps.getUploadProgressAriaLabel : _ref$getUploadProgres,
      _ref$getUploadProgres2 = _ref.getUploadProgressSummary,
      getUploadProgressSummary = _ref$getUploadProgres2 === void 0 ? defaultProps.getUploadProgressSummary : _ref$getUploadProgres2,
      id = _ref.id,
      _ref$isMulti = _ref.isMulti,
      isMulti = _ref$isMulti === void 0 ? defaultProps.isMulti : _ref$isMulti,
      _ref$maxFiles = _ref.maxFiles,
      maxFiles = _ref$maxFiles === void 0 ? 0 : _ref$maxFiles,
      onFileAttached = _ref.onFileAttached,
      _ref$renderFileDetail = _ref.renderFileDetailsIcon,
      renderFileDetailsIcon = _ref$renderFileDetail === void 0 ? defaultProps.renderFileDetailsIcon : _ref$renderFileDetail,
      _ref$renderFileDetail2 = _ref.renderFileDetailsLabel,
      renderFileDetailsLabel = _ref$renderFileDetail2 === void 0 ? defaultProps.renderFileDetailsLabel : _ref$renderFileDetail2,
      _ref$renderRejectedEr = _ref.renderRejectedErrorText,
      renderRejectedErrorText = _ref$renderRejectedEr === void 0 ? defaultProps.renderRejectedErrorText : _ref$renderRejectedEr,
      _ref$retryButtonText = _ref.retryButtonText,
      retryButtonText = _ref$retryButtonText === void 0 ? defaultProps.retryButtonText : _ref$retryButtonText,
      _ref$showDropZone = _ref.showDropZone,
      showDropZone = _ref$showDropZone === void 0 ? defaultProps.showDropZone : _ref$showDropZone,
      _ref$showFileDetails = _ref.showFileDetails,
      showFileDetails = _ref$showFileDetails === void 0 ? defaultProps.showFileDetails : _ref$showFileDetails,
      uploadButtonAriaDescribedby = _ref.uploadButtonAriaDescribedby,
      uploadButtonSize = _ref.uploadButtonSize,
      _ref$uploadButtonTitl = _ref.uploadButtonTitle,
      uploadButtonTitle = _ref$uploadButtonTitl === void 0 ? defaultProps.uploadButtonTitle : _ref$uploadButtonTitl,
      uploadButtonVariant = _ref.uploadButtonVariant,
      uploadHandler = _ref.uploadHandler,
      _ref$uploadIconTitle = _ref.uploadIconTitle,
      uploadIconTitle = _ref$uploadIconTitle === void 0 ? defaultProps.uploadIconTitle : _ref$uploadIconTitle,
      _ref$uploadProgressAr = _ref.uploadProgressAriaLive,
      uploadProgressAriaLive = _ref$uploadProgressAr === void 0 ? defaultProps.uploadProgressAriaLive : _ref$uploadProgressAr,
      forwardedProps = _objectWithoutProperties(_ref, _excluded);

  var removeFileButtonsRefMap = useRef({});

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      files = _useState2[0],
      setFiles = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      failedFiles = _useState4[0],
      setFailedFiles = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      rejectedFilesLength = _useState6[0],
      setRejectedFilesLength = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      requests = _useState8[0],
      setRequests = _useState8[1];

  var _useBreakpoints = useBreakpoints(),
      matches = _useBreakpoints.matches;

  var buttonRef = useRef(null);

  if (buttonRefProp) {
    buttonRef = buttonRefProp;
  }

  var isInCardLayout = matches['s'];
  var isWithDropZone = showDropZone || isMulti;
  var onUploadBegin = useCallback(function (acceptedFiles, fileRejections) {
    onFileAttached(acceptedFiles);
    setFiles(acceptedFiles);

    if (acceptedFiles.length > 0 && uploadHandler) {
      uploadHandler({
        files: acceptedFiles,
        setFiles: setFiles,
        setFailedFiles: setFailedFiles,
        setRequests: setRequests
      });
    }

    setRejectedFilesLength(fileRejections.length);
  }, [uploadHandler, onFileAttached]);

  var _useDropzone = useDropzone({
    accept: accept,
    disabled: disabled,
    maxFiles: maxFiles,
    noKeyboard: true,
    multiple: isMulti,
    onDrop: onUploadBegin
  }),
      getInputProps = _useDropzone.getInputProps,
      getRootProps = _useDropzone.getRootProps,
      open = _useDropzone.open;

  var handleFocus = function handleFocus(index) {
    if (removeFileButtonsRefMap.current && buttonRef.current) {
      var refsLength = Object.values(removeFileButtonsRefMap.current).filter(function (v) {
        return !!v;
      }).length;

      if (refsLength > 1) {
        setTimeout(function () {
          var focusIndex = refsLength === index + 1 ? index - 1 : index;
          removeFileButtonsRefMap.current[focusIndex].focus();
        }, 100);
      } else {
        buttonRef.current.focus();
      }
    }
  };

  var sharedProps = {
    buttonRef: buttonRef,
    cancelButtonText: cancelButtonText,
    cancelUploadButtonTitle: cancelUploadButtonTitle,
    deleteFileButtonTitle: deleteFileButtonTitle,
    disabled: disabled,
    errorText: errorText,
    failedFiles: failedFiles,
    files: files,
    getUploadProgressAriaLabel: getUploadProgressAriaLabel,
    getUploadProgressSummary: getUploadProgressSummary,
    handleFocus: handleFocus,
    id: id,
    isInCardLayout: isInCardLayout,
    isMulti: isMulti,
    maxFiles: maxFiles,
    onFileAttached: onFileAttached,
    open: open,
    rejectedFilesLength: rejectedFilesLength,
    removeFileButtonsRefMap: removeFileButtonsRefMap,
    renderFileDetailsIcon: renderFileDetailsIcon,
    renderFileDetailsLabel: renderFileDetailsLabel,
    renderRejectedErrorText: renderRejectedErrorText,
    requests: requests,
    retryButtonText: retryButtonText,
    setFailedFiles: setFailedFiles,
    setFiles: setFiles,
    setRequests: setRequests,
    showDropZone: showDropZone,
    showFileDetails: showFileDetails,
    uploadButtonAriaDescribedby: uploadButtonAriaDescribedby,
    uploadButtonSize: uploadButtonSize,
    uploadButtonTitle: uploadButtonTitle,
    uploadButtonVariant: uploadButtonVariant,
    uploadHandler: uploadHandler,
    uploadIconTitle: uploadIconTitle,
    uploadProgressAriaLive: uploadProgressAriaLive
  };
  return ___EmotionJSX(Col, _extends({}, pickDataProps(forwardedProps), {
    gridGap: FILE_UPLOAD_BLOCKS_SPACER_HEIGHT,
    ref: ref,
    tabIndex: -1,
    width: "100%"
  }), ___EmotionJSX("input", getInputProps()), isWithDropZone ? ___EmotionJSX(FileUploadWithDropzone, _extends({}, sharedProps, {
    dragAndDropText: dragAndDropText,
    getRootProps: getRootProps
  })) : ___EmotionJSX(FileUploadWithoutDropzone, sharedProps));
});
var FileUploadWithDocs = describe(FileUploadWithoutDocs).description('Component to upload files');
FileUploadWithDocs.propTypes = FileUploadPropTypes;
FileUploadWithDocs.defaultProps = defaultProps;
var FileUpload = withTestAttributes({
  component: 'StencilReactFileUpload'
})(FileUploadWithDocs);
FileUpload.displayName = 'FileUpload';
export default FileUpload;